import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
// import _ from "lodash"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"

const Wrapper = styled.div`
  margin-top: 2%;

  #carouselTitle {
    margin: 0px 8px;
    text-align: left;

    @media only screen and (max-width: 599px) {
      margin: 0px 16px;
    }
  }

  div[class^="CarouselSlider__SliderButtonContainer"] {
    z-index: 99;
  }
`

export default function LocationCarousel(props) {
  const { data } = props

  const cardData = data.cards.map(card => {
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: "",
      currencyCode: "",
      discount: "",
      hidden: "",
      image: card.image_url,
      imageAlt: card.image_alt_attribute,
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: null,
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: "",
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: card.subtitle,
      timer: "",
      title: card.title,
      url: card.url,
    }
  })

  const gtmUserType = getGtmUserType()

  return (
    <Wrapper>
      {data.headline && (
        <Title
          type="h2"
          customProperties={{
            id: "carouselTitle",
          }}
        >
          {data.headline}
        </Title>
      )}
      <Carousel
        accessible
        cardConfig={{
          focusEffect: true,
          width: "100%",
          titleTextType: "medium",
          color: "default",
          hasOverlay: true,
          customOverlayProperties: {
            overlayHeight: "80%",
            overlayBackground:
              "linear-gradient(0deg, #000000 4.3%, rgba(0, 0, 0, 0) 96.12%)",
            overlayZIndex: "1",
          },
          borderRadius: "4px 4px 0px 0px",
          color: "default",
        }}
        data={[...cardData]}
        heading={{
          cardCount: "5",
          gtmParameters: {
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: `${GTM_PROJECT_CATEGORY} | Internal Linking Carousel | ${props.gtmConsumerName}`,
            eventLabelCardClick: `${GTM_PROJECT_CATEGORY} | ${gtmUserType} | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
            eventLabelHeadlineClick: `${gtmUserType}  | headline | {{headline}}`,
            eventLabelView: `${GTM_PROJECT_CATEGORY} | ${gtmUserType}`,
          },
          headline: "",
          headlineType: "h2",
          headlineStyle: "h2",
          layoutName: "lob_widget",
          showMoreURL: "",
          subHeadline: data.subheadline,
          widgetID: "",
          widgetName: "Hotel Location Widget",
          widgetWidth: "3",
        }}
        fireGtm={obj => {
          fireGtmEvent(obj)
        }}
        // isLoading={CardData.length === 0}
        templateType="productCard"
        lazyLoadImage={false}
        enableProgressiveImageLoading={false}
      />
    </Wrapper>
  )
}
